import { Fab, Tooltip } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import clsx from 'clsx'
import { motion } from 'framer-motion'

interface Props {
  children: React.ReactNode | (React.ReactNode | string)[]
  tooltipTitle?: string
  [key: string]: any
  className?: any
  sx?: any
}

const useStyles = makeStyles(() => ({
  root: {
    '&&': {
      position: 'relative',
      width: '38px',
      height: '38px',
      minHeight: '38px',
      minWidth: '38px',
      color: 'white',
      boxShadow: 'none',
      borderRadius: '20px',
    },
  },
}))

/**
 * The animated motion button wrapper
 *
 * @param props React props
 * @param {ReactNode} props.children ReactNode elements nested inside the container
 * @param {string} tooltipTitle The title for the Material UI Tooltip component
 * @returns
 */
export const MotionFab = ({ children, tooltipTitle = '', className, ...props }: Props) => {
  const classes = useStyles()

  return (
    <Tooltip title={tooltipTitle}>
      <Fab
        variant="circular"
        {...props}
        className={clsx(classes.root, className)}
        component={motion.button}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      >
        {children}
      </Fab>
    </Tooltip>
  )
}
